module.exports = global["XRegExp"] = require("-!/data/jenkins_data/workspace/Printos_skyline-start_develop/node_modules/xregexp/src/index.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?XRegExp!../~/xregexp/src/index.js
// module id = 147
// module chunks = 1